export const IdAzureIntroFormId = "id-azure-intro";

export enum IdAzureIntroSubFormsId {
  ContactAndStudio = "contactAndStudio",
}

export const IdAzureIntroSubFormsIdsOrder = [IdAzureIntroSubFormsId.ContactAndStudio];

export const IdAzureIntroSubFormsLocalizedStringIds: { [subForm: string]: string } = {
  ["formTitle"]: "introFormsTitle",
  ["formSubtitle"]: "",
  [IdAzureIntroSubFormsId.ContactAndStudio]: "introIdAzureContactInformationTitle",
};
